import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateUser } from "src/modules/user/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createUser } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await createUser(values);
        router.push("/user");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateUser)(Create);
